import React from 'react'
import Product from '../../Components/Product/Product'

function Home() {
  return (
    <div>

        <Product/>


    </div>
  )
}

export default Home